export default __webpack_public_path__ + "static/10-9e92e3313a593eed86ac835417af57db.jpg";